// @ts-nocheck
// todo: clean up, not used
import isEmpty from 'lodash/isEmpty';
import debounce from 'lodash/debounce';
import SVG from 'react-inlinesvg';
import { parse, stringify } from 'svgson';

interface SvgJsonProps {
  content: any;
  onClick: () => void;
}

export const SvgJson = ({ content = {}, onClick = (e: any) => {} }: SvgJsonProps) => {
  if (isEmpty(content)) return null;
  const svgStr = stringify(content);
  const handler = e => {
    if (e && e.target) {
      //e.target is the element of the SVG. Not the whole svg. Just what was clicked
      const svgNodeMarkup = e.target.outerHTML;
      if (!isEmpty(svgNodeMarkup)) {
        //to get it to parse to JSON we have to shove it into <svg> tag
        parse('<svg>' + e.target.outerHTML + '</svg>').then(json => {
          onClick(json.children[0]); //and then we have to yank it out of the artificial <svg> tag
        });
      }
    }
  };
  return <SVG src={svgStr} onClick={handler} />;
};
